<template>
    <div>
        <v-card v-if="userInformations && resetLink && resetLink.STATUS === 'ACTIVE' && resetLink.USED === 'NO'">
            <v-container>
                <div v-if="!configSuccess">
                    <v-card-title>{{ $t('passAccount.configuration.title') }}</v-card-title>
                    <v-card-text>
                        <p>{{ $t('passAccount.configuration.your_profil') }}</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.my_id') }}</td>
                                    <td>{{ userInformations.geodisLogin }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.firstname') }}</td>
                                    <td>{{ userInformations.firstname }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.lastname') }}</td>
                                    <td>{{ userInformations.lastname }}</td>
                                </tr>
                                <tr>
                                    <td class="key">{{ $t('passwordLost.change.mail') }}</td>
                                    <td>{{ userInformations.mail }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                        <p>{{ $t('passAccount.configuration.define') }}</p>
                        <br />
                        <p>{{ $t('passAccount.configuration.for_security') }}</p>
                        <ChangePassword
                            ref="PasswordForm"
                            @password-is-valid="onPasswordIsValid"
                            @password-changed="onPasswordChanged"
                            onlyFields="true"
                        ></ChangePassword>
                        <div class="actions">
                            <v-btn class="action" :disabled="!isValid" @click="submit">
                                {{ $t('passAccount.configuration.finished') }}
                            </v-btn>
                        </div>
                    </v-card-text>
                </div>
                <v-card-text class="passwordChangeSuccess" v-else>
                    <div v-html="successMsg.webTextContent"></div>
                </v-card-text>
            </v-container>
            <v-snackbar v-model="snackbar.display" :timeout="snackbar.timeout">
                {{ snackbar.text }}
            </v-snackbar>
        </v-card>
        <v-card v-else-if="errorMsg && resetLink && (resetLink.STATUS === 'OBSOLETE' || resetLink.USED === 'YES')">
            <div class="errorMessage" v-html="errorMsg.webTextContent"></div>
        </v-card>
    </div>
</template>

<script>
import { api } from '@utils/api';
import { i18n } from '@plugins/vuetify';

import ChangePassword from '@components/ChangePassword';

export default {
    components: {
        ChangePassword
    },
    data() {
        return {
            userInformations: null,
            resetLink: null,
            areValid: {
                password: null
            },
            snackbar: {
                display: false,
                text: '',
                timeout: 2000
            },
            configSuccess: false,
            successMsg: null,
            successMsgFr: null,
            successMsgEn: null,
            errorMsg: null,
            errorMsgFr: null,
            errorMsgEn: null
        };
    },
    methods: {
        onPasswordIsValid(check) {
            this.areValid.password = check;
        },
        async onPasswordChanged(result) {
            if (result === true) {
                const result = await api.get(
                    'validateUser',
                    { UUID: this.$route.params.UUID, login: this.userInformations.geodisLogin },
                    { withCredentials: true },
                    'accMgmt'
                );
                if (result) {
                    const textsWeb = await api.get('textsWebById', { id: this.resetLink.IS_G3 ? 4 : 5 }, null, 'accMgmt');
                    this.successMsgEn = textsWeb.find(tw => tw.language === 'en');
                    this.successMsgFr = textsWeb.find(tw => tw.language === 'fr');
                    this.successMsg = this.$i18n.locale === 'fr' ? this.successMsgFr : this.successMsgEn;
                    this.configSuccess = true;
                } else {
                    this.snackbar.text = i18n.t('passAccount.common.configurationFailed');
                    this.snackbar.display = true;
                }
            }
        },
        async submit() {
            this.$refs.PasswordForm.submit();
        }
    },
    computed: {
        isValid() {
            return this.areValid.password;
        }
    },
    async created() {
        const anonymous = await api.get('anonymous', null, null, 'admin');
        this.resetLink = await api.get('findGeodisLogin', { UUID: this.$route.params.UUID }, { withCredentials: true }, 'accMgmt');

        if (
            this.resetLink === null ||
            (this.resetLink &&
                this.resetLink.TYPE !== 'ILM13' &&
                this.resetLink.TYPE !== 'ILM1' &&
                this.resetLink.TYPE !== 'ILM21' &&
                this.resetLink.TYPE !== 'ILM22')
        ) {
            return this.$router.push('/login');
        }

        const textsWeb = await api.get('textsWebById', { id: 3 }, null, 'accMgmt');
        this.errorMsgEn = textsWeb.find(tw => tw.language === 'en');
        this.errorMsgFr = textsWeb.find(tw => tw.language === 'fr');
        this.errorMsg = this.$i18n.locale === 'fr' ? this.errorMsgFr : this.errorMsgEn;

        if (anonymous && anonymous.message === 'anonymous succeed') {
            this.userInformations = await api.post(
                'userInfo',
                { geodisLogin: this.resetLink.GEODIS_LOGIN },
                { withCredentials: true },
                'accMgmt'
            );
            this.$session.set(
                'accMgmt-configuration-informations',
                btoa(unescape(encodeURIComponent(JSON.stringify(this.userInformations))))
            );
        }
    },
    watch: {
        '$i18n.locale'() {
            this.successMsg = this.$i18n.locale === 'fr' ? this.successMsgFr : this.successMsgEn;
            this.errorMsg = this.$i18n.locale === 'fr' ? this.errorMsgFr : this.errorMsgEn;
        }
    }
};
</script>

<style lang="scss" scoped>
.actions {
    margin-top: 20px;
}

table {
    .key {
        padding-right: 40px;
    }
}

.errorMessage {
    padding: 10px;
    background: #f8d7da;
    box-shadow: 0 0px 4px red;
    color: red;
    font-weight: 400;
}

.passwordChangeSuccess {
    box-shadow: 0px 0px 3px #3200e6;
    color: #3200e6;
    font-weight: 600;
}
</style>
